// The status card: the honeypot, points, level, badge count, the meter to
// the next level. When the points change the number counts up and pops.
import { useLayoutEffect, useRef } from 'react';
import { Card } from './Card';
import { Icon } from './Icon';
import { Meter } from './Meter';
import { countUp, pop } from './motion';

export interface ScoreCardProps {
  points: number;
  level: string;
  next?: string;
  toNext: number;
  /** 0 to 1 between this level and the next. */
  fraction: number;
  badges: number;
  className?: string;
}

const fmt = (n: number) => n.toLocaleString('en-GB');

export function ScoreCard({ points, level, next, toNext, fraction, badges, className }: ScoreCardProps) {
  const num = useRef<HTMLSpanElement>(null);
  const shown = useRef(points);
  // Before paint, so the new number is never seen before the count starts.
  useLayoutEffect(() => {
    const from = shown.current;
    shown.current = points;
    if (from !== points && num.current) { countUp(num.current, from, points, 500, fmt); pop(num.current); }
  }, [points]);
  return (
    <Card className={className ? `score ${className}` : 'score'}>
      <img className="score-pot" src="/art/honeypot.svg" alt="" width={58} height={58} />
      <p className="score-pts"><span className="num" ref={num}>{fmt(points)}</span> honey points</p>
      <p className="score-lvl">{level}</p>
      <div className="score-badge" role="img" aria-label={`${badges} badges`}>
        <Icon name="ribbon" />
        <span className="num">{badges}</span>
      </div>
      <Meter value={fraction} label={next ? `Progress to ${next}` : 'Top level reached'} className="score-meter" />
      <p className="score-next">{next ? `${toNext} points to ${next}` : 'The top of the ladder.'}</p>
    </Card>
  );
}
